import React from 'react';
import { Form, Col } from 'react-bootstrap';
import { Controller } from 'react-hook-form';
import { getNestedError } from '../../utils/formUtils'; // Corrected import path

const FormInput = ({ name, label, control, errors, type = "text", as = "input", isRequired = false, customOnChange = null, rows = 1, hidden = false, md = 4, ...props }) => (
    <Form.Group className="mb-4 text-start" style={{ display: hidden ? 'none' : 'block' }}>
        <Form.Label className="form-label">{label} {isRequired && <span className="text-danger">*</span>}</Form.Label> 
        <Controller name={name} control={control} render={({ field }) => (
            <Form.Control {...field} {...props} type={type} as={as} rows={as === "textarea" ? rows : undefined} 
                          isInvalid={!!getNestedError(errors, name)} className="custom-form-input shadow-none" 
                          onChange={customOnChange || field.onChange} />
        )} />
        {getNestedError(errors, name) && <Form.Control.Feedback type="invalid">{getNestedError(errors, name)?.message}</Form.Control.Feedback>}
    </Form.Group>
);

export default FormInput;